import { BASE_URL, COMMON_BASE_URL } from "../../../envs";
import { Charity } from "../../../types/charity/charity";
import { HttpClient } from "../http-client";

export class CharitiesClient {

  private readonly httpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async getCharity(charityId: string): Promise<Charity> {
    const response = await this.httpClient.fetch(`${BASE_URL}/charities/${charityId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Error while retrieving charity: ${response.status}`)
    }
    return await response.json()
  }

  async getMyCharities(): Promise<Charity[]> {
    const response = await this.httpClient.fetch(`${COMMON_BASE_URL}/charities`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error(`Error while retrieving charities: ${response.status}`)
    }
    return await response.json()
  }
}
